import * as React from 'react';

interface Props {
    height: number;
    width: number;
    color?: string;
}

class WaterIcon extends React.Component<Props, {}> {

    public render(): JSX.Element {
        return (
            <svg 
                xmlns="http://www.w3.org/2000/svg"
                viewBox="7965.76 3669.841 41.563 59.747" 
                width={this.props.width} 
                height={this.props.height}
            >
                <g id="tint-drop" transform="translate(7922.76 3691.841)">
                    <path 
                        fill={this.props.color} 
                        d="M102.23,27.8q-.244-.365-2.537-3.673T95.593,18q-1.806-2.821-4.038-7.225A50.493,50.493,0,0,1,88.186,2.6,3.211,3.211,0,0,0,86.826.69,3.733,3.733,0,0,0,84.737,0a3.646,3.646,0,0,0-2.07.69A3.421,3.421,0,0,0,81.287,2.6a50.537,50.537,0,0,1-3.369,8.179Q75.686,15.18,73.88,18t-4.1,6.129q-2.293,3.308-2.537,3.673a20.771,20.771,0,0,0-3.288,11.162,20.021,20.021,0,0,0,6.088,14.693,20.773,20.773,0,0,0,29.386,0,20.023,20.023,0,0,0,6.089-14.693A20.364,20.364,0,0,0,102.23,27.8ZM83.215,47.834a5.2,5.2,0,0,1-8.869-3.673,5.328,5.328,0,0,1,.812-2.8c.027-.028.237-.331.629-.913s.737-1.1,1.035-1.543a18.072,18.072,0,0,0,1.015-1.786,12.823,12.823,0,0,0,.852-2.049.884.884,0,0,1,1.7,0,12.835,12.835,0,0,0,.852,2.049A18.114,18.114,0,0,0,82.261,38.9q.446.67,1.035,1.543c.392.582.6.885.629.913a5.327,5.327,0,0,1,.811,2.8A5.007,5.007,0,0,1,83.215,47.834Z"
                        transform="translate(-20.956 -22)"
                    />
                </g>
            </svg>
        );
    }
}

export default WaterIcon;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/components/svgs/WaterIcon.tsx